var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.settings.api_key && !_vm.feedError && !_vm.feedLoaded,
              expression: "(settings.api_key) && !feedError && !feedLoaded"
            }
          ],
          class:
            "eventbrite-modal-spinner-feed eventbrite-modal-spinner-feed-" +
            _vm.uid
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "eventbrite-modal-spinner-text" }, [
            _c("p", [_vm._v(_vm._s(_vm.translations.loading_text))])
          ])
        ]
      ),
      _vm._v(" "),
      _vm.settings.api_key && _vm.events && _vm.events.length > 0
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.feedLoaded,
                  expression: "feedLoaded"
                }
              ],
              class:
                "eventbrite-feed eventbrite-feed-id-" +
                _vm.feed.ID +
                " eventbrite-feed-widget " +
                _vm.feed.css_classes,
              attrs: { id: _vm.feed.css_id }
            },
            [
              _vm.admin && _vm.edit_url
                ? _c(
                    "a",
                    {
                      staticClass: "eventbrite-feed-edit-link",
                      attrs: { target: "_blank", href: _vm.edit_url }
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticStyle: { "enable-background": "new 0 0 64 64" },
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            fill: "#334ecd",
                            width: "16",
                            height: "16",
                            version: "1.1",
                            id: "lni_lni-pencil-alt",
                            x: "0px",
                            y: "0px",
                            viewBox: "0 0 64 64",
                            "xml:space": "preserve"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              d:
                                "M62.7,11.2c0-0.7-0.3-1.3-0.8-1.8c-1.3-1.3-2.5-2.5-3.7-3.7c-1.1-1.1-2.2-2.2-3.3-3.4c-0.4-0.5-1-0.9-1.6-1  c-0.7-0.1-1.5,0.1-2.1,0.6l-7.2,7.2H8.7c-4.1,0-7.4,3.3-7.4,7.4v38.9c0,4.1,3.3,7.4,7.4,7.4h38.9c4.1,0,7.4-3.3,7.4-7.4V19.9  l6.9-6.9C62.4,12.5,62.7,11.8,62.7,11.2z M33.3,36.6c-0.1,0.1-0.3,0.2-0.4,0.3l-8.6,2.9l2.8-8.6c0.1-0.2,0.1-0.3,0.3-0.4l19-19  l6,5.9L33.3,36.6z M51.5,55.4c0,2.1-1.7,3.9-3.9,3.9H8.7c-2.1,0-3.9-1.7-3.9-3.9V16.4c0-2.1,1.7-3.9,3.9-3.9h31.9L24.9,28.2  c-0.5,0.5-0.9,1.1-1.1,1.8l-3.8,11.6c-0.2,0.6-0.1,1.2,0.2,1.7c0.3,0.4,0.7,0.8,1.6,0.8h0.3l11.9-3.9c0.7-0.2,1.3-0.6,1.8-1.1  l15.8-15.7V55.4z M54.8,15.1l-6-5.9l4-4c1,1,1.9,1.9,2.9,2.9c1,1,2,2,3,3.1L54.8,15.1z"
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.translations.edit_link_text))
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.events, function(event, eventIndex) {
                return _c(
                  "div",
                  {
                    key: event.ID,
                    staticClass: "eventbrite-item",
                    attrs: {
                      "data-event-id": event.ID,
                      "data-event-index": eventIndex
                    }
                  },
                  [
                    _vm.feed.display_image && event.url
                      ? _c("div", { staticClass: "eventbrite-item-image" }, [
                          _c(
                            "div",
                            {
                              staticClass: "eventbrite-item-image-inner",
                              on: {
                                click: function($event) {
                                  return _vm.getEventDetails(event, eventIndex)
                                }
                              }
                            },
                            [
                              event.vue.image
                                ? _c("img", {
                                    attrs: {
                                      src: event.vue.image,
                                      alt: event.post_title,
                                      loading: "lazy"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              (_vm.feed.display_price ||
                                _vm.feed.display_tickets) &&
                              _vm.feed.price_overlay
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "eventbrite-item-image-tags"
                                    },
                                    [
                                      _vm.feed.display_price && event.vue.price
                                        ? _c("span", {
                                            staticClass:
                                              "eventbrite-item-image-price",
                                            domProps: {
                                              innerHTML: _vm._s(event.vue.price)
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.feed.display_tickets &&
                                      event.tickets_remaining &&
                                      event.tickets_remaining > 0
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "eventbrite-item-image-available-tickets"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  event.tickets_remaining
                                                ) +
                                                  _vm._s(
                                                    _vm.ticketsText(
                                                      _vm.feed.tickets_text
                                                    )
                                                  )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "eventbrite-item-content" }, [
                      _c("div", { staticClass: "eventbrite-item-top-row" }, [
                        _c(
                          "div",
                          { staticClass: "eventbrite-item-title-col" },
                          [
                            _vm.feed.display_datetime && event.vue.start
                              ? _c(
                                  "time",
                                  { staticClass: "eventbrite-item-datetime" },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(event.vue.start) +
                                        " - " +
                                        _vm._s(event.vue.end) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            event.vue.title
                              ? _c(
                                  "h3",
                                  {
                                    staticClass: "eventbrite-item-title",
                                    on: {
                                      click: function($event) {
                                        return _vm.getEventDetails(
                                          event,
                                          eventIndex
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(event.vue.title) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm.feed.display_location ||
                      _vm.feed.display_description ||
                      (_vm.feed.display_price &&
                        !_vm.feed.display_image &&
                        event.vue.price) ||
                      _vm.feed.display_signup_button ||
                      _vm.feed.display_more_button
                        ? _c(
                            "div",
                            { staticClass: "eventbrite-item-bottom-row" },
                            [
                              _vm.feed.display_location
                                ? _c(
                                    "p",
                                    { staticClass: "eventbrite-item-location" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "eventbrite-item-location-icon-wrapper"
                                        },
                                        [
                                          event.vue.location !== "Online"
                                            ? _c(
                                                "svg",
                                                {
                                                  staticClass:
                                                    "eventbrite-item-location-icon",
                                                  staticStyle: {
                                                    "enable-background":
                                                      "new 0 0 48 64"
                                                  },
                                                  attrs: {
                                                    version: "1.1",
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    "xmlns:xlink":
                                                      "http://www.w3.org/1999/xlink",
                                                    x: "0px",
                                                    y: "0px",
                                                    viewBox: "0 0 48 64",
                                                    "xml:space": "preserve"
                                                  }
                                                },
                                                [
                                                  _c("g", [
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M24,0C10.7,0,0,11.2,0,25.3c0,12,16.5,31.7,21.6,37.6c0.5,0.8,1.6,1.1,2.4,1.1c1.1,0,1.9-0.5,2.4-1.1 C31.5,57.1,48,37.1,48,25.3C48,11.2,37.3,0,24,0z M24,57.6C14.9,46.9,5.3,32.8,5.3,25.3c0-11.2,8.3-20,18.7-20s18.7,9.1,18.7,20 C42.7,32.8,33.1,46.9,24,57.6z"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M24,13.3c-5.9,0-10.7,4.8-10.7,10.7S18.1,34.7,24,34.7S34.7,29.9,34.7,24S29.9,13.3,24,13.3z M24,29.3 c-2.9,0-5.3-2.4-5.3-5.3s2.4-5.3,5.3-5.3s5.3,2.4,5.3,5.3S26.9,29.3,24,29.3z"
                                                      }
                                                    })
                                                  ])
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          event.vue.location == "Online"
                                            ? _c(
                                                "svg",
                                                {
                                                  staticClass:
                                                    "eventbrite-item-location-icon-online",
                                                  staticStyle: {
                                                    "enable-background":
                                                      "new 0 0 64.1 48"
                                                  },
                                                  attrs: {
                                                    version: "1.1",
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    "xmlns:xlink":
                                                      "http://www.w3.org/1999/xlink",
                                                    x: "0px",
                                                    y: "0px",
                                                    viewBox: "0 0 64.1 48",
                                                    "xml:space": "preserve"
                                                  }
                                                },
                                                [
                                                  _c("g", [
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M32,13.9c-3.5,0-6.4,2.9-6.4,6.1c0,2.4,1.6,4.5,3.7,5.6v19.7c0,1.6,1.1,2.7,2.7,2.7s2.7-1.1,2.7-2.7V25.9 c2.1-1.1,3.7-3.2,3.7-5.6C38.4,16.8,35.5,13.9,32,13.9z M32,19.2c0.5,0,1.1,0.5,1.1,0.8s-0.5,0.8-1.1,0.8c-0.5,0-1.1-0.5-1.1-0.8 S31.5,19.2,32,19.2z"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M24.5,10.9c-1.1-1.1-2.7-1.1-3.7,0c-2.4,2.4-3.5,5.3-3.5,8.5s1.3,6.4,3.5,8.8c0.5,0.5,1.3,0.8,1.9,0.8 c0.8,0,1.3-0.3,1.9-0.8c1.1-1.1,1.1-2.7,0-3.7c-1.3-1.3-2.1-2.9-2.1-4.8s0.8-3.5,2.1-4.8C25.6,13.6,25.6,12,24.5,10.9z"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M43.2,10.9c-1.1-1.1-2.7-1.1-3.7,0c-1.1,1.1-1.1,2.7,0,3.7c1.3,1.3,2.1,2.9,2.1,4.8s-0.8,3.5-2.1,4.8 c-1.1,1.1-1.1,2.7,0,3.7c0.5,0.5,1.3,0.8,1.9,0.8c0.8,0,1.3-0.3,1.9-0.8c2.4-2.4,3.5-5.3,3.5-8.8C46.9,16.3,45.6,13.1,43.2,10.9z"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M13.9,19.5c0-3.7,1.3-7.2,4-9.9c1.1-1.1,1.1-2.7,0-3.7c-1.1-1.1-2.7-1.1-3.7,0c-3.7,3.7-5.6,8.5-5.6,13.6s2.1,9.9,5.6,13.6 c0.5,0.5,1.1,0.8,1.9,0.8s1.3-0.3,1.9-0.8c1.1-1.1,1.1-2.7,0-3.7C15.5,26.7,13.9,23.2,13.9,19.5z"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M49.9,5.9c-1.1-1.1-2.7-1.1-3.7,0s-1.1,2.7,0,3.7c2.7,2.7,4,6.1,4,9.9s-1.3,7.2-4,9.9c-1.1,1.1-1.1,2.7,0,3.7 c0.5,0.5,1.3,0.8,1.9,0.8c0.8,0,1.3-0.3,1.9-0.8c3.7-3.7,5.6-8.5,5.6-13.6C55.5,14.4,53.3,9.3,49.9,5.9z"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M5.3,19.5c0-5.6,2.1-10.9,6.1-14.9c1.1-1.1,1.1-2.7,0-3.7s-2.7-1.1-3.7,0C2.7,5.9,0,12.3,0,19.5s2.7,13.6,7.7,18.7 C8.2,38.7,8.8,39,9.6,39c0.8,0,1.3-0.3,1.9-0.8c1.1-1.1,1.1-2.7,0-3.7C7.5,30.4,5.3,25.1,5.3,19.5z"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M56.3,0.8c-1.1-1.1-2.7-1.1-3.7,0s-1.1,2.7,0,3.7c4,4,6.1,9.3,6.1,14.9s-2.1,10.9-6.1,14.9c-1.1,1.1-1.1,2.7,0,3.7 c0.5,0.5,1.3,0.8,1.9,0.8c0.8,0,1.3-0.3,1.9-0.8c5.1-5.1,7.7-11.7,7.7-18.7S61.3,5.9,56.3,0.8z"
                                                      }
                                                    })
                                                  ])
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(event.vue.location))
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.feed.display_description
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "eventbrite-item-description"
                                    },
                                    [_vm._v(_vm._s(event.vue.description))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              (_vm.feed.display_price ||
                                _vm.feed.display_tickets) &&
                              !_vm.feed.price_overlay
                                ? _c(
                                    "div",
                                    { staticClass: "eventbrite-item-tags" },
                                    [
                                      _vm.feed.display_price && event.vue.price
                                        ? _c("div", {
                                            staticClass:
                                              "eventbrite-item-price",
                                            domProps: {
                                              innerHTML: _vm._s(event.vue.price)
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.feed.display_tickets &&
                                      event.tickets_remaining &&
                                      event.tickets_remaining > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "eventbrite-item-available-tickets"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  event.tickets_remaining
                                                ) +
                                                  _vm._s(
                                                    _vm.ticketsText(
                                                      _vm.feed.tickets_text
                                                    )
                                                  )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.feed.display_signup_button ||
                              _vm.feed.display_more_button
                                ? _c(
                                    "div",
                                    { staticClass: "eventbrite-item-buttons" },
                                    [
                                      event.event_sales_status.sales_status ==
                                        "on_sale" &&
                                      _vm.feed.display_signup_button
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "eventbrite-item-checkout",
                                              attrs: {
                                                id:
                                                  "eventbrite-checkout-button-" +
                                                  event.ID
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.checkoutFromEventCard(
                                                    event,
                                                    eventIndex
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm.checkoutButtonText(
                                                      event
                                                    )
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.feed.display_more_button
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "eventbrite-item-details",
                                              on: {
                                                click: function($event) {
                                                  return _vm.getEventDetails(
                                                    event,
                                                    eventIndex
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm.feed.more_button_text
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    ])
                  ]
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.events && _vm.events.length === 0
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.feedLoaded,
                  expression: "feedLoaded"
                }
              ],
              staticClass: "eventbrite-info-message"
            },
            [_vm._v(_vm._s(_vm.translations.no_events_text))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.feedError == true
        ? _c("div", { staticClass: "eventbrite-info-message" }, [
            _vm._v(_vm._s(_vm.translations.loading_error_text))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.settings.api_key == false
        ? _c("div", { staticClass: "eventbrite-info-message" }, [
            _vm._v(_vm._s(_vm.translations.api_error_text))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.events && _vm.events.length > 0 && _vm.settings.show_copyright
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.feedLoaded,
                  expression: "feedLoaded"
                }
              ],
              staticClass: "eventbrite-copyright eventbrite-copyright-left"
            },
            [
              _c("div", [_vm._v(_vm._s(_vm.translations.copyright_text))]),
              _vm._v(" "),
              _vm._m(1)
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "Modal",
        {
          attrs: {
            "modal-class":
              "eventbrite-modal scrollable-modal eventbrite-modal-" +
              _vm.uid +
              " eventbrite-modal-id-" +
              _vm.feed.ID,
            "bg-class": "eventbrite-modal-bg",
            "wrapper-class": "eventbrite-modal-wrapper",
            "append-to": "#eventbrite-modal-container",
            "base-zindex": "20000",
            live: false
          },
          on: {
            "before-open": _vm.beforeOpen,
            "before-close": _vm.beforeClose,
            "after-close": _vm.afterClose,
            "after-open": _vm.afterOpen
          },
          model: {
            value: _vm.modalShow,
            callback: function($$v) {
              _vm.modalShow = $$v
            },
            expression: "modalShow"
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "scroll-lock",
                  rawName: "v-scroll-lock",
                  value: _vm.modalShow,
                  expression: "modalShow"
                }
              ],
              staticClass: "scroll-content"
            },
            [
              _vm.feed.popup
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.modalAddBackBtn == true,
                          expression: "modalAddBackBtn == true"
                        }
                      ],
                      staticClass: "eventbrite-modal-back"
                    },
                    [
                      _c(
                        "button",
                        {
                          attrs: {
                            type: "button",
                            title: _vm.translations.back_button_text
                          },
                          on: { click: _vm.backBtnClick }
                        },
                        [
                          _c("i", [
                            _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                              _c("path", {
                                attrs: {
                                  "fill-rule": "evenodd",
                                  "clip-rule": "evenodd",
                                  d:
                                    "M4 12l8 8 1.5-1.5L8 13h12v-2H8l5.5-5.5L12 4z"
                                }
                              })
                            ])
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "eventbrite-modal-close" }, [
                _c(
                  "button",
                  {
                    attrs: {
                      type: "button",
                      title: _vm.translations.close_button_text
                    },
                    on: {
                      click: function($event) {
                        ;(_vm.modalShow = false) && (_vm.requestModal = false)
                      }
                    }
                  },
                  [
                    _c("i", [
                      _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                        _c("path", {
                          attrs: {
                            d:
                              "M13.4 12l3.5-3.5-1.4-1.4-3.5 3.5-3.5-3.5-1.4 1.4 3.5 3.5-3.5 3.5 1.4 1.4 3.5-3.5 3.5 3.5 1.4-1.4z"
                          }
                        })
                      ])
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "eventbrite-modal-img",
                  attrs: { id: "eventbrite-modal-img" }
                },
                [
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.modalImage !== false,
                        expression: "modalImage !== false"
                      }
                    ],
                    attrs: {
                      src: _vm.modalImage,
                      alt: _vm.modalEvent.post_title,
                      loading: "lazy"
                    }
                  }),
                  _vm._v(" "),
                  _vm.feed.calendar_button == true &&
                  _vm.license == true && _vm.free != true
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "eventbrite-modal-add-to-calendar-wrapper"
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "eventbrite-modal-add-to-calendar",
                              attrs: { type: "button" },
                              on: { click: _vm.toggleModalCalendarAdd }
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "h-6 w-6",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor"
                                  }
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2",
                                      d:
                                        "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.translations.add_to_calendar_text)
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.modalCalendarAdd,
                                  expression: "modalCalendarAdd"
                                }
                              ],
                              staticClass:
                                "eventbrite-modal-add-to-calendar-menu"
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "eventbrite-modal-add-to-calendar-menu-close",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      _vm.modalCalendarAdd = false
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticStyle: {
                                        "enable-background": "new 0 0 64 64"
                                      },
                                      attrs: {
                                        version: "1.1",
                                        id: "Layer_1",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "xmlns:xlink":
                                          "http://www.w3.org/1999/xlink",
                                        x: "0px",
                                        y: "0px",
                                        viewBox: "0 0 64 64",
                                        "xml:space": "preserve"
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d:
                                            "M35.4,32l19.9-19.9c1-1,1-2.4,0-3.4s-2.4-1-3.4,0L32,28.6L12,8.8c-0.9-1-2.4-1-3.3,0s-1,2.4,0,3.4L28.6,32L8.7,51.9\n                                    c-1,1-1,2.4,0,3.4c0.5,0.4,1,0.7,1.7,0.7s1.2-0.2,1.7-0.7l20-19.9l20,19.8c0.5,0.4,1.2,0.7,1.7,0.7c0.5,0,1.2-0.2,1.7-0.7\n                                    c1-1,1-2.4,0-3.4L35.4,32z"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "eventbrite-modal-add-to-calendar-menu-item eventbrite-modal-add-to-calendar-menu-item-google",
                                  attrs: {
                                    href: "javascript:;",
                                    target: "_blank"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.modalCalendarAdd = false
                                    }
                                  }
                                },
                                [_vm._v("Google Calendar")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "eventbrite-modal-add-to-calendar-menu-item eventbrite-modal-add-to-calendar-menu-item-outlook",
                                  attrs: {
                                    href: "javascript:;",
                                    target: "_blank"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.modalCalendarAdd = false
                                    }
                                  }
                                },
                                [_vm._v("Outlook Calendar")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "eventbrite-modal-add-to-calendar-menu-item eventbrite-modal-add-to-calendar-menu-item-office",
                                  attrs: {
                                    href: "javascript:;",
                                    target: "_blank"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.modalCalendarAdd = false
                                    }
                                  }
                                },
                                [_vm._v("Office365 Calendar")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "eventbrite-modal-add-to-calendar-menu-item eventbrite-modal-add-to-calendar-menu-item-yahoo",
                                  attrs: {
                                    href: "javascript:;",
                                    target: "_blank"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.modalCalendarAdd = false
                                    }
                                  }
                                },
                                [_vm._v("Yahoo Calendar")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "eventbrite-modal-add-to-calendar-menu-item eventbrite-modal-add-to-calendar-menu-item-apple",
                                  attrs: { href: "javascript:;" },
                                  on: {
                                    click: function($event) {
                                      _vm.modalCalendarAdd = false
                                    }
                                  }
                                },
                                [_vm._v("Download ICS file")]
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.modalTickets,
                      expression: "!modalTickets"
                    }
                  ],
                  staticClass: "eventbrite-modal-title"
                },
                [
                  _vm.modalEvent.vue &&
                  _vm.modalEvent.vue.start_full &&
                  _vm.modalEvent.vue.end_full
                    ? _c("div", { staticClass: "eventbrite-modal-datetime" }, [
                        _c("time", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.modalEvent.vue.start_full) +
                              " - " +
                              _vm._s(_vm.modalEvent.vue.end_full) +
                              "\n                    "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.modalEvent.post_title
                    ? _c("h3", [_vm._v(_vm._s(_vm.modalEvent.post_title))])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.modalEvent.vue && _vm.modalEvent.vue.location
                    ? _c(
                        "div",
                        {
                          staticClass: "eventbrite-modal-location",
                          class: {
                            "eventbrite-modal-location-clickable":
                              _vm.modalEvent.venue.address &&
                              _vm.feed.calendar_button == true
                          },
                          on: {
                            click: function($event) {
                              return _vm.modalScrollToMap(
                                _vm.modalEvent.vue.location
                              )
                            }
                          }
                        },
                        [
                          _vm.modalEvent.vue.location !== "Online"
                            ? _c(
                                "svg",
                                {
                                  staticClass: "eventbrite-modal-location-icon",
                                  staticStyle: {
                                    "enable-background": "new 0 0 48 64"
                                  },
                                  attrs: {
                                    version: "1.1",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "xmlns:xlink":
                                      "http://www.w3.org/1999/xlink",
                                    x: "0px",
                                    y: "0px",
                                    viewBox: "0 0 48 64",
                                    "xml:space": "preserve"
                                  }
                                },
                                [
                                  _c("g", [
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M24,0C10.7,0,0,11.2,0,25.3c0,12,16.5,31.7,21.6,37.6c0.5,0.8,1.6,1.1,2.4,1.1c1.1,0,1.9-0.5,2.4-1.1 C31.5,57.1,48,37.1,48,25.3C48,11.2,37.3,0,24,0z M24,57.6C14.9,46.9,5.3,32.8,5.3,25.3c0-11.2,8.3-20,18.7-20s18.7,9.1,18.7,20 C42.7,32.8,33.1,46.9,24,57.6z"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M24,13.3c-5.9,0-10.7,4.8-10.7,10.7S18.1,34.7,24,34.7S34.7,29.9,34.7,24S29.9,13.3,24,13.3z M24,29.3 c-2.9,0-5.3-2.4-5.3-5.3s2.4-5.3,5.3-5.3s5.3,2.4,5.3,5.3S26.9,29.3,24,29.3z"
                                      }
                                    })
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.modalEvent.vue.location == "Online"
                            ? _c(
                                "svg",
                                {
                                  staticClass:
                                    "eventbrite-modal-location-icon-online",
                                  staticStyle: {
                                    "enable-background": "new 0 0 64.1 48"
                                  },
                                  attrs: {
                                    version: "1.1",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "xmlns:xlink":
                                      "http://www.w3.org/1999/xlink",
                                    x: "0px",
                                    y: "0px",
                                    viewBox: "0 0 64.1 48",
                                    "xml:space": "preserve"
                                  }
                                },
                                [
                                  _c("g", [
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M32,13.9c-3.5,0-6.4,2.9-6.4,6.1c0,2.4,1.6,4.5,3.7,5.6v19.7c0,1.6,1.1,2.7,2.7,2.7s2.7-1.1,2.7-2.7V25.9 c2.1-1.1,3.7-3.2,3.7-5.6C38.4,16.8,35.5,13.9,32,13.9z M32,19.2c0.5,0,1.1,0.5,1.1,0.8s-0.5,0.8-1.1,0.8c-0.5,0-1.1-0.5-1.1-0.8 S31.5,19.2,32,19.2z"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M24.5,10.9c-1.1-1.1-2.7-1.1-3.7,0c-2.4,2.4-3.5,5.3-3.5,8.5s1.3,6.4,3.5,8.8c0.5,0.5,1.3,0.8,1.9,0.8 c0.8,0,1.3-0.3,1.9-0.8c1.1-1.1,1.1-2.7,0-3.7c-1.3-1.3-2.1-2.9-2.1-4.8s0.8-3.5,2.1-4.8C25.6,13.6,25.6,12,24.5,10.9z"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M43.2,10.9c-1.1-1.1-2.7-1.1-3.7,0c-1.1,1.1-1.1,2.7,0,3.7c1.3,1.3,2.1,2.9,2.1,4.8s-0.8,3.5-2.1,4.8 c-1.1,1.1-1.1,2.7,0,3.7c0.5,0.5,1.3,0.8,1.9,0.8c0.8,0,1.3-0.3,1.9-0.8c2.4-2.4,3.5-5.3,3.5-8.8C46.9,16.3,45.6,13.1,43.2,10.9z"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M13.9,19.5c0-3.7,1.3-7.2,4-9.9c1.1-1.1,1.1-2.7,0-3.7c-1.1-1.1-2.7-1.1-3.7,0c-3.7,3.7-5.6,8.5-5.6,13.6s2.1,9.9,5.6,13.6 c0.5,0.5,1.1,0.8,1.9,0.8s1.3-0.3,1.9-0.8c1.1-1.1,1.1-2.7,0-3.7C15.5,26.7,13.9,23.2,13.9,19.5z"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M49.9,5.9c-1.1-1.1-2.7-1.1-3.7,0s-1.1,2.7,0,3.7c2.7,2.7,4,6.1,4,9.9s-1.3,7.2-4,9.9c-1.1,1.1-1.1,2.7,0,3.7 c0.5,0.5,1.3,0.8,1.9,0.8c0.8,0,1.3-0.3,1.9-0.8c3.7-3.7,5.6-8.5,5.6-13.6C55.5,14.4,53.3,9.3,49.9,5.9z"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M5.3,19.5c0-5.6,2.1-10.9,6.1-14.9c1.1-1.1,1.1-2.7,0-3.7s-2.7-1.1-3.7,0C2.7,5.9,0,12.3,0,19.5s2.7,13.6,7.7,18.7 C8.2,38.7,8.8,39,9.6,39c0.8,0,1.3-0.3,1.9-0.8c1.1-1.1,1.1-2.7,0-3.7C7.5,30.4,5.3,25.1,5.3,19.5z"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M56.3,0.8c-1.1-1.1-2.7-1.1-3.7,0s-1.1,2.7,0,3.7c4,4,6.1,9.3,6.1,14.9s-2.1,10.9-6.1,14.9c-1.1,1.1-1.1,2.7,0,3.7 c0.5,0.5,1.3,0.8,1.9,0.8c0.8,0,1.3-0.3,1.9-0.8c5.1-5.1,7.7-11.7,7.7-18.7S61.3,5.9,56.3,0.8z"
                                      }
                                    })
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.modalEvent.vue.location))
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "eventbrite-modal-content" }, [
                _c("div", { staticClass: "replace-content" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.modalTickets,
                          expression: "!modalTickets"
                        }
                      ],
                      staticClass: "eventbrite-modal-event-info"
                    },
                    [
                      _vm.modalEvent.vue && _vm.modalEvent.post_content
                        ? _c("p", { staticClass: "eventbrite-modal-summary" }, [
                            _vm._v(_vm._s(_vm.modalEvent.post_content))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.modalDescription, function(description) {
                        return _c("div", {
                          key: description.ID,
                          staticClass: "eventbrite-modal-description-module",
                          class: {
                            "eventbrite-modal-description-module-text":
                              description.data.body,
                            "eventbrite-modal-description-module-img":
                              description.data.image,
                            "eventbrite-modal-description-module-video":
                              description.data.video
                          },
                          domProps: {
                            innerHTML: _vm._s(_vm.moduleContent(description))
                          }
                        })
                      }),
                      _vm._v(" "),
                      _vm.modalError == true
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "eventbrite-modal-description-module eventbrite-modal-description-module-text eventbrite-modal-description-error"
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(_vm.translations.modal_error_text) +
                                    " "
                                ),
                                _c("br"),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.modalEvent.url,
                                      target:
                                        _vm.feed.link_target_blank == true
                                          ? "_blank"
                                          : "_self"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.translations.modal_error_link)
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.modalTickets,
                          expression: "modalTickets"
                        }
                      ],
                      staticClass: "eventbrite-modal-event-tickets"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "eventbrite-modal-content-spinner-wrapper"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "eventbrite-modal-spinner" },
                            [
                              _c("div", { staticClass: "double-bounce1" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "double-bounce2" })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: {
                          position: "relative",
                          "background-color": "#fff",
                          "z-index": "1"
                        },
                        attrs: { id: "eventbrite-modal-event-tickets" }
                      })
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.modalEvent.vue &&
              _vm.modalEvent.venue.address &&
              _vm.feed.google_map == true
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.modalTickets,
                          expression: "!modalTickets"
                        }
                      ],
                      staticClass: "eventbrite-modal-map",
                      attrs: { id: "eventbrite-modal-map" }
                    },
                    [
                      _c("iframe", {
                        attrs: {
                          width: "100%",
                          height: "250",
                          frameborder: "0",
                          scrolling: "no",
                          marginheight: "0",
                          marginwidth: "0",
                          src: _vm.googleMapsSrc(this.modalEvent.vue.location),
                          loading: "lazy"
                        }
                      })
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.modalEvent.organizer &&
              _vm.modalEvent.organizer.name &&
              _vm.feed.organizer_info == true
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.modalTickets,
                          expression: "!modalTickets"
                        }
                      ],
                      staticClass: "eventbrite-modal-organizer"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "eventbrite-modal-organizer-row" },
                        [
                          _vm.modalOrganizer &&
                          _vm.modalOrganizer.logo &&
                          _vm.modalOrganizer.logo.url
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "eventbrite-modal-organizer-image"
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.modalOrganizer.logo.url,
                                      alt: "modalOrganizer.name"
                                    }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "eventbrite-modal-organizer-info" },
                            [
                              _vm.modalEvent.organizer.name
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "eventbrite-modal-organizer-name"
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.modalEvent.organizer.name)
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "eventbrite-modal-organizer-title"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.translations.organizer_title)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.modalEvent.organizer.description
                                ? _c("div", {
                                    staticClass:
                                      "eventbrite-modal-organizer-description",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.modalEvent.organizer.description
                                          .html
                                      )
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.modalOrganizer
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "eventbrite-modal-organizer-social"
                                    },
                                    [
                                      _vm.modalOrganizer.facebook
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "eventbrite-modal-organizer-social-twitter",
                                              attrs: {
                                                href:
                                                  "https://www.facebook.com/" +
                                                  _vm.modalOrganizer.facebook,
                                                target:
                                                  _vm.feed.link_target_blank ==
                                                  true
                                                    ? "_blank"
                                                    : "_self",
                                                title: "Facebook"
                                              }
                                            },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  staticClass:
                                                    "svg-inline--fa fa-facebook-f fa-w-10",
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    "aria-hidden": "true",
                                                    focusable: "false",
                                                    "data-prefix": "fab",
                                                    "data-icon": "facebook-f",
                                                    role: "img",
                                                    viewBox: "0 0 320 512"
                                                  }
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      fill: "currentColor",
                                                      d:
                                                        "M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.modalOrganizer.twitter
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "eventbrite-modal-organizer-social-website",
                                              attrs: {
                                                href:
                                                  "https://www.twitter.com/" +
                                                  _vm.modalOrganizer.twitter,
                                                target:
                                                  _vm.feed.link_target_blank ==
                                                  true
                                                    ? "_blank"
                                                    : "_self",
                                                title: "Twitter"
                                              }
                                            },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  staticClass:
                                                    "svg-inline--fa fa-twitter fa-w-16",
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    "aria-hidden": "true",
                                                    focusable: "false",
                                                    "data-prefix": "fab",
                                                    "data-icon": "twitter",
                                                    role: "img",
                                                    viewBox: "0 0 512 512"
                                                  }
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      fill: "currentColor",
                                                      d:
                                                        "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.modalEvent.organizer.website
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "eventbrite-modal-organizer-social-facebook",
                                              attrs: {
                                                href:
                                                  _vm.modalEvent.organizer
                                                    .website,
                                                target:
                                                  _vm.feed.link_target_blank ==
                                                  true
                                                    ? "_blank"
                                                    : "_self",
                                                title:
                                                  _vm.translations
                                                    .organizer_link
                                              }
                                            },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  staticClass:
                                                    "svg-inline--fa fa-globe fa-w-16",
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    "aria-hidden": "true",
                                                    focusable: "false",
                                                    "data-prefix": "far",
                                                    "data-icon": "globe",
                                                    role: "img",
                                                    viewBox: "0 0 496 512"
                                                  }
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      fill: "currentColor",
                                                      d:
                                                        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm179.3 160h-67.2c-6.7-36.5-17.5-68.8-31.2-94.7 42.9 19 77.7 52.7 98.4 94.7zM248 56c18.6 0 48.6 41.2 63.2 112H184.8C199.4 97.2 229.4 56 248 56zM48 256c0-13.7 1.4-27.1 4-40h77.7c-1 13.1-1.7 26.3-1.7 40s.7 26.9 1.7 40H52c-2.6-12.9-4-26.3-4-40zm20.7 88h67.2c6.7 36.5 17.5 68.8 31.2 94.7-42.9-19-77.7-52.7-98.4-94.7zm67.2-176H68.7c20.7-42 55.5-75.7 98.4-94.7-13.7 25.9-24.5 58.2-31.2 94.7zM248 456c-18.6 0-48.6-41.2-63.2-112h126.5c-14.7 70.8-44.7 112-63.3 112zm70.1-160H177.9c-1.1-12.8-1.9-26-1.9-40s.8-27.2 1.9-40h140.3c1.1 12.8 1.9 26 1.9 40s-.9 27.2-2 40zm10.8 142.7c13.7-25.9 24.4-58.2 31.2-94.7h67.2c-20.7 42-55.5 75.7-98.4 94.7zM366.3 296c1-13.1 1.7-26.3 1.7-40s-.7-26.9-1.7-40H444c2.6 12.9 4 26.3 4 40s-1.4 27.1-4 40h-77.7z"
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.modalTickets,
                  expression: "!modalTickets"
                }
              ],
              staticClass: "noscroll-content"
            },
            [
              _vm.feed.eventbrite_link == true
                ? _c("div", { staticClass: "eventbrite-modal-footer-left" }, [
                    _c(
                      "a",
                      {
                        staticClass: "eventbrite-modal-external-button",
                        attrs: {
                          href: _vm.modalEvent.url,
                          target:
                            _vm.feed.link_target_blank == true
                              ? "_blank"
                              : "_self"
                        }
                      },
                      [
                        _c("span", { staticClass: "desktop" }, [
                          _vm._v(_vm._s(_vm.translations.eventbrite_link) + " ")
                        ]),
                        _c("span", { staticClass: "mobile" }, [
                          _vm._v("Eventbrite")
                        ])
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "eventbrite-modal-footer-right" }, [
                _vm.modalEvent.vue &&
                _vm.modalEvent.vue.price &&
                _vm.feed.display_price
                  ? _c("div", {
                      staticClass: "eventbrite-modal-price",
                      domProps: { innerHTML: _vm._s(_vm.modalEvent.vue.price) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.modalEvent &&
                _vm.modalEvent.event_sales_status.sales_status == "on_sale"
                  ? _c(
                      "button",
                      {
                        staticClass: "eventbrite-modal-checkout-button",
                        on: {
                          click: function($event) {
                            return _vm.toOrder(
                              _vm.modalEvent,
                              _vm.modalEventIndex
                            )
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.checkoutButtonText(_vm.modalEvent)) +
                            "\n                "
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class:
            "eventbrite-modal-spinner-wrapper eventbrite-modal-spinner-wrapper-" +
            _vm.uid
        },
        [_vm._m(2)]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "eventbrite-modal-spinner" }, [
      _c("div", { staticClass: "double-bounce1" }),
      _vm._v(" "),
      _c("div", { staticClass: "double-bounce2" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { attrs: { href: "https://eventfeed.click/", target: "_blank" } },
      [
        _c("span", { staticClass: "brand-text" }, [
          _c("strong", [_vm._v("Event Feed")]),
          _vm._v(" for Eventbrite")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "eventbrite-modal-spinner" }, [
      _c("div", { staticClass: "double-bounce1" }),
      _vm._v(" "),
      _c("div", { staticClass: "double-bounce2" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }